import { render, staticRenderFns } from "./videoes.vue?vue&type=template&id=2b25134b&scoped=true"
import script from "./videoes.vue?vue&type=script&lang=js"
export * from "./videoes.vue?vue&type=script&lang=js"
import style0 from "./videoes.vue?vue&type=style&index=0&id=2b25134b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25134b",
  null
  
)

export default component.exports